import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { deleteDataPromise, putDataPromise } from 'brock-fetch-utils';
import EditorLayout from './EditorLayout';
import DashboardContext from '../shared/hooks/dashboardContext';
import { useLabelContext } from '../shared/hooks/labelContext';
import { getErrorMessageToDisplay } from '../viewDashboards/widgets/utils/wrapperUtils';

export default function Edit(props) {
    const { dashboardLabels } = useLabelContext();
    const { menuUtilities, uriConstants } = useContext(DashboardContext);
    const [errorMessage, setErrorMessage] = useState();

    function navigateToCustomDashboard(
        dashboardConfiguration,
        dashboardKey,
        hasPendingChanges
    ) {
        props.history.push({
            pathname: `/Custom/${dashboardKey}`,
            state: {
                isCreateMode: false,
                hasPendingChanges,
                dashboardConfiguration: JSON.stringify(dashboardConfiguration),
            },
        });
    }

    function saveDashboard(configuration) {
        const dashboardConfiguration = JSON.stringify(configuration);

        Promise.all([
            putDataPromise(uriConstants.editUserDashboardUri, {
                dashboardKey: props.dashboardKey,
                dashboardConfiguration,
            }),
            menuUtilities.saveUserDashboard(
                props.dashboardKey,
                configuration.title
            ),
        ]).then(
            () => {
                props.reloadPageTo(`/Custom/${props.dashboardKey}`);
            },
            (error) =>
                setErrorMessage(
                    getErrorMessageToDisplay(
                        error,
                        dashboardLabels.errorSavingLandingPage
                    )
                )
        );
    }

    function deleteDashboard() {
        Promise.all([
            deleteDataPromise(
                uriConstants.getDeleteUserDashboardUri(props.dashboardKey)
            ),
            menuUtilities.deleteUserDashboard(props.dashboardKey),
        ]).then(() => {
            props.reloadPageTo('/Custom/Create');
        });
    }

    if (errorMessage) {
        throw Error(errorMessage);
    }

    return (
        <EditorLayout
            customDashboardConfigurationUri={uriConstants.getUserDashboardConfigurationUri(
                props.dashboardKey
            )}
            dashboardConfiguration={props.dashboardConfiguration}
            dashboardKey={props.dashboardKey}
            deleteDashboard={deleteDashboard}
            errorMessage={errorMessage}
            hasPendingChanges={props.hasPendingChanges}
            navigateToCustomDashboard={navigateToCustomDashboard}
            saveDashboard={saveDashboard}
            selectedWidgetId={props.selectedWidgetId}
        />
    );
}

Edit.propTypes = {
    dashboardConfiguration: PropTypes.instanceOf(Object),
    dashboardKey: PropTypes.string.isRequired,
    hasPendingChanges: PropTypes.bool,
    history: PropTypes.instanceOf(Object).isRequired,
    reloadPageTo: PropTypes.func.isRequired,
    selectedWidgetId: PropTypes.string,
};
